import React from 'react';
import { OrdemDeServicoCompleta } from '../../types/ordemServico';
import { RefreshCw, User, DollarSign, Receipt } from 'lucide-react';
import { MaskedValue } from '../common/ProtectedField';

interface OsRepassesDespesasSectionProps {
  os: OrdemDeServicoCompleta;
}

export const OsRepassesDespesasSection: React.FC<OsRepassesDespesasSectionProps> = ({ os }) => {
  const agregadoNome = os.veiculos?.agregado?.nome || os.agregado_nome || 'Nenhum agregado ligado';

  return (
    <div className="space-y-4 pt-4 border-t border-slate-200">
      <div className="flex items-center gap-2 border-b border-slate-100 pb-2">
        <RefreshCw className="w-4 h-4 text-red-600" />
        <h3 className="text-sm font-bold uppercase tracking-wider text-slate-700">Repasses e Despesas</h3>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
        {/* Agregado */}
        <div className="p-3.5 bg-slate-50 border border-slate-200/80 rounded-xl">
          <span className="text-xs text-slate-400 font-semibold block uppercase flex items-center gap-1">
            <User className="w-3.5 h-3.5" /> Agregado
          </span>
          <span className="text-sm font-bold text-slate-900 mt-0.5 block">{agregadoNome}</span>
        </div>

        {/* Valor de Repasse */}
        <div className="p-3.5 bg-slate-50 border border-slate-200/80 rounded-xl">
          <span className="text-xs text-slate-400 font-semibold block uppercase flex items-center gap-1">
            <DollarSign className="w-3.5 h-3.5 text-blue-600" /> Valor de Repasse
          </span>
          <span className="text-sm font-bold text-slate-900 mt-0.5 block">
            <MaskedValue
              value={os.repasse}
              permission="view_order_repasse"
              type="currency"
            />
          </span>
        </div>

        {/* Despesas Extras */}
        <div className="p-3.5 bg-slate-50 border border-slate-200/80 rounded-xl">
          <span className="text-xs text-slate-400 font-semibold block uppercase flex items-center gap-1">
            <Receipt className="w-3.5 h-3.5 text-amber-600" /> Despesas Extras
          </span>
          <span className="text-sm font-medium text-slate-800 mt-0.5 block">{os.despesas || 'Nenhuma despesa extra'}</span>
        </div>

        {/* Valor da Despesa */}
        <div className="p-3.5 bg-slate-50 border border-slate-200/80 rounded-xl">
          <span className="text-xs text-slate-400 font-semibold block uppercase flex items-center gap-1">
            <DollarSign className="w-3.5 h-3.5 text-rose-600" /> Valor da Despesa
          </span>
          <span className="text-sm font-bold text-rose-600 mt-0.5 block">
            <MaskedValue
              value={os.valor_despesa}
              permission="view_order_prices"
              type="currency"
            />
          </span>
        </div>
      </div>
    </div>
  );
};
